import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const ModalStyle = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  bottom: 0;
  transition: opacity 0.1s ease-out;
  opacity: 0;
  height: 0;
  overflow: hidden;
  z-index: 1;

  &.isOpen {
    overflow: scroll;
    opacity: 1;
    height: auto;
    z-index: 4;
  }

  .modal-bg {
    background-color: #0000007a;
    height: 100vh;
    width: 100vw;
    position: sticky;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .modal-content {
    background-color: white;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 20px;
    width: 100%;
    height: 100%;
    // min-height: 400px;

    @media only screen and (min-width: ${Variable.mobile}) {
      width: 400px;
      height: auto;
    }

    .modal-body {
      top: calc(50% + 20px);
      transform: translateY(-50%);
      position: absolute;
      margin: 0 auto;
      left: 0;
      right: 0;
      padding: 20px;

      @media only screen and (min-width: ${Variable.mobile}) {
        position: static;
        padding: 12px 0 0;
        transform: none;
      }

      .modal-title {
        margin-top: 0;
        font-weight: 600;
        font-size: 3rem;

        @media only screen and (min-width: ${Variable.mobile}) {
          margin-top: 20px;
        }
      }
    }
  }

  &.addressModal {
    .modal-content {
      top: 0;
      transform: none;

      @media only screen and (min-width: ${Variable.mobile}) {
        top: 30px;
      }
    }
  }

  &.sign-in-modal {
    .modal-content {
      min-height: 400px;

      .signin-modal-loader {
        z-index: -1;
      }
      .gigya-signin-div {
        background-color: #fff;
        * {
          max-width: 100%;
        }
      }
    }
  }
  button {
    &:focus {
      outline: none;
    }
  }
`;

export const ModalCloseStyle = styled.button`
  background: none;
  border: none;
  padding: 0;
  float: right;
  cursor: pointer;
`;
